module.exports = function mapGeolibCoordsToArray(coords) {
  return [
    coords.latitude,
    coords.longitude,
  ];
};
